import React, { Fragment,useEffect } from 'react';
import welcomeImage from 'Assets/img/svg/welcomeImage.svg';
import singleFlower from 'Assets/img/svg/singleFlower.svg';
import { welcome } from 'Utils/GeneralCopy';
import { NextButton } from 'Components/Reusable/Buttons/Buttons';
import { useStyles } from './welcome.style';
import { GetProfile, updateWelcome} from '../../ReduxStore/profile/Action'
import { useDispatch, useSelector } from 'react-redux'
import {useHistory } from 'react-router-dom'
const Welcome:React.FC = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();

	const handleChange  = () => {
			dispatch(updateWelcome())
			history.push('/menu')
		};
	
	return (
		<Fragment>
			<div
				className={`${classes.root} d-flex flex-column flex-nowrap justify-content-center align-items-center`}
			>
				<img src={welcomeImage} alt="" className={classes.welcomeImage} />
				<h3 className={`${classes.welcomeTitle}`}>{welcome.welcome}</h3>
				<p className={`${classes.welcomeMessage} text-center`}>{welcome.welcomeMessage}</p>
				<div
					className={`${classes.bottomFooter} d-flex flex-row flex-nowrap justify-content-between w-100 px-5 py-4`}
				>
					<img src={singleFlower} alt="" />
					<NextButton
					onClick={() => handleChange()}
					common={{ width: '49px', height: '48px', roundSvgBackground: '#7FD6DD', arrowSvgColor: 'white' }}
					/>
				</div>
			</div>
		</Fragment>
	);
};

export default Welcome;
